import React from 'react';
import CreateCards from './pages/createCards';

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <CreateCards />
      </div>
    );
  }
}

export default App;
